export default "__VITE_ASSET__DL6oH1HV__"